import { createContext } from 'react';
import type { ReactElement } from 'react';
import type { StepNode, TapTarget } from '@segmently/schema-models/v2';

/** Ephemeral renderer extension. No schema/persisted fields and no payment service
 * dependency: editor/Stripe consumers keep their original purchase button by default. */
export interface PurchaseSlotInput {
  action: TapTarget;
  step: StepNode;
  productId?: string;
  source: 'paywall' | 'flexibleLayout';
  sectionId?: string;
  disabled?: boolean;
  fallback: ReactElement;
}
export type PurchaseSlotRenderer = (input: PurchaseSlotInput) => ReactElement;
export const PurchaseSlotContext = createContext<PurchaseSlotRenderer | null>(null);
